import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App'
import '@/shared/i18n/i18n'
import '@fontsource/inter/300.css'
import '@fontsource/inter/400.css'
import '@fontsource/inter/500.css'
import '@fontsource/inter/600.css'

const rootElement = document.getElementById('root')
if (!rootElement) {
    throw new Error('Root element not found. Check that index.html has <div id="root">.')
}

ReactDOM.createRoot(rootElement).render(
    <React.StrictMode>
        <App />
    </React.StrictMode>
)
